const refetchDiaryAndEnergy = async (queryClient, currentDay) => {
    try {
        await queryClient.refetchQueries({ queryKey: ['diary', currentDay] });
        await queryClient.refetchQueries({ queryKey: ['energy', 'period'], exact: false });
    } catch (error) {
        console.error('Refetch failed:', error);
    }
};

export default refetchDiaryAndEnergy;
